<template>
<div class="associate-group-ms-notification-template">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="closeCurrentOverlay()">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-left-0Px text-align-right padding-right-0Px">
                  Notification Scheduled For:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <select class="form-control" v-model="msTeamsNotificationType" :disabled="disableGroupDDSelection">
                      <option value='-1' disabled>Select</option>
                      <option v-for="msTypeEnum in getMsTeamsNotificationTypeEnum" v-bind:key="msTypeEnum" v-bind:value="msTypeEnum">{{ getMSNotifTypeEnum(msTypeEnum) }}</option>
                    </select>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Active:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <input type="checkbox" v-model="isActiveValue" :disabled="disableGroupDDSelection">
                  </div>
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="msTeamsNotificationType !== -1">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Group:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <select class="form-control" v-model="currSelectedGroupObj" :disabled="disableGroupDDSelection">
                      <option value='-1' disabled>Select</option>
                      <option v-for="groupObj in getGroupListValue" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-5 col-lg-5"></div>
              </div>
              <div class="row margin-bottom-2Perc" v-if="currSelectedGroupObj !== -1 && msTeamsNotificationType !== -1">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Template(s):
                </div>
                <div class="col-md-7 col-lg-7">
                  <div class="form-group">
                    <!-- <div class="text-align-left">
                      <input type="checkbox" v-model="selectAllSelectedValue" >&nbsp;&nbsp;&nbsp; Select All
                    </div> -->
                    <div class="text-align-left" v-for="msNotificationTemplateObj in msNotificationTemplateListValue" :key="msNotificationTemplateObj.MSNotificationTemplateId">
                      <input type="radio" v-model="associatedGroupMSNotifTemplateIdValue" :value="msNotificationTemplateObj.MSNotificationTemplateId">&nbsp;&nbsp;&nbsp; {{msNotificationTemplateObj.TemplateTitle}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="associateGroupWithMSNotificationTemplate">Associate</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <loader></loader>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { msNotificationService } from '@/server-util/ms-notification-service'
import { find } from 'lodash'
export default {
  props: ['groupId'],
  created: function () {
    this.getGroupList()
    this.getMSNotificationTemplateList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedGroupObj: -1,
      associatedGroupMSNotifTemplateId: null,
      isMSNotificationTemplateAssociatedSuccessfully: false,
      createObj: null,
      selectAllSelected: false,
      disableGroupDDSelection: false,
      isActive: false,
      msTeamsNotificationType: -1
    }
  },
  name: 'associate-group-ms-notification-template',
  methods: {
    getMSNotifTypeEnum: function (msNotifType) {
      var valueToReturn = ''
      switch (msNotifType) {
        case constants.MsTeamsNotificationTypeEnum.Preparation:
          valueToReturn = 'Preparation'
          break
        case constants.MsTeamsNotificationTypeEnum.Reflection:
          valueToReturn = 'Reflection'
          break
        default:
          valueToReturn = 'Not Found'
          break
      }
      return valueToReturn
    },
    setDefaultValues: function () {
      if (this.groupId !== undefined && this.groupId !== 'undefined' && this.groupId !== null && this.groupId !== 'null' && this.groupId !== '') {
        this.currSelectedGroupObj = find(this.$store.state.groupList, (obj) => {
          return this.groupId === obj.GroupId
        })
        if (this.currSelectedGroupObj === undefined || this.currSelectedGroupObj === 'undefined' || this.currSelectedGroupObj === null || this.currSelectedGroupObj === 'null' || this.currSelectedGroupObj === '') {
          this.currSelectedGroupObj = -1
          this.disableGroupDDSelection = false
        } else {
          this.disableGroupDDSelection = true
        }
      }
    },
    closeCurrentOverlay: function () {
      var objToReturn = {
        operationName: 'close_overlay',
        createdObj: null
      }
      this.$emit('updateValues', objToReturn)
    },
    resetValuesToDefault: function () {
      this.associatedGroupMSNotifTemplateId = null
      this.currSelectedGroupObj = null
      this.isActiveValue = false
      this.msTeamsNotificationType = -1
    },
    associateGroupWithMSNotificationTemplate: function () {
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          this.$store.state.isLoading = true
          var objToPost = {
            GroupId: this.currSelectedGroupObj.GroupId,
            MSNotificationTemplateId: this.associatedGroupMSNotifTemplateIdValue,
            IsActive: this.isActiveValue,
            MsTeamsNotificationType: this.msTeamsNotificationType
          }
          groupService
            .associateGroupWithMSNotificationTemplate(
              storeObj.state.access_token,
              objToPost
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.createObj = responseObj.data
                this.isMSNotificationTemplateAssociatedSuccessfully = true
                this.showAlertDialog = true
                this.errorMsg = 'Selected Template associated successfully with \'' + this.currSelectedGroupObj.GroupName + '\'.'
                this.$store.state.isLoading = false
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined ASSCOIATE GROUP WITH MS NOTIFICIATION TEMPLATE'
          )
        }
      }
    },
    getMSNotificationTemplateList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.msNotificationTemplateList.length === 0) {
          this.$store.state.isLoading = true
        }
        msNotificationService
          .getMSNotificationTemplateList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.msNotificationTemplateList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING MS NOTIFICATION TEMPLATE LIST'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isMSNotificationTemplateAssociatedSuccessfully) {
        this.closeCurrentOverlay()
        this.isMSNotificationTemplateAssociatedSuccessfully = false
        this.resetValuesToDefault()
      }
    },
    getGroupList: function () {
      var storeObj = this.$store
      var groupListPresent = false
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          this.$store.state.isLoading = true
        } else {
          groupListPresent = true
          this.setDefaultValues()
        }
        groupService
          .listGroups(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              if (!groupListPresent) {
                this.setDefaultValues()
              }
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.msTeamsNotificationType === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Notification Schedule For can\'t be empty.'
        return false
      } else if (this.currSelectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.associatedGroupMSNotifTemplateId === undefined || this.associatedGroupMSNotifTemplateId === 'undefined' || this.associatedGroupMSNotifTemplateId === null || this.associatedGroupMSNotifTemplateId === 'null' || this.associatedGroupMSNotifTemplateId === '' || this.associatedGroupMSNotifTemplateId.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one Template to associate with \'' + this.currSelectedGroupObj.GroupName + '\'.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getMsTeamsNotificationTypeEnum: {
      get: function () {
        return constants.MsTeamsNotificationTypeEnum
      }
    },
    isActiveValue: {
      get: function () {
        return this.isActive
      },
      set: function (newValue) {
        this.isActive = newValue
      }
    },
    getGroupListValue: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    msNotificationTemplateListValue: {
      get: function () {
        return this.$store.state.msNotificationTemplateList
      }
    },
    associatedGroupMSNotifTemplateIdValue: {
      get: function () {
        return this.associatedGroupMSNotifTemplateId
      },
      set: function (newValue) {
        this.associatedGroupMSNotifTemplateId = newValue
      }
    }
  },
  watch: {
    groupId: function (newValue, oldValue) {
      this.setDefaultValues()
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/group/AssociateGroupMSNotificationTemplateOverlay.vue